import React, { useState } from "react";
import { connect } from "react-redux";
import { Tooltip } from "react-tooltip";

import { stringToPascal, getIsHideNonInventoryOptions } from "../../utility";
import UserDropdown from "./UserDropdown";
import NotificationMenu from "./NotificationsMenu";
import { InfoIcon, UserIcon } from "../../../assets/icons/iconsProvider";
import Button from "../Buttons/Button";
import {
  buttonNameConstants,
  buttonTypeConstants,
  routesPathConstants,
} from "../../../constants";
import { useNavigate } from "react-router";

const TopbarUserContainer = (props) => {
  const [isShown, setIsShown] = useState(false);
  const navigate = useNavigate();
  const isHideNonInventoryOptions = getIsHideNonInventoryOptions(
    props.currentStore
  );

  return (
    <div className="d-flex justify-content-center align-items-center">
      <NotificationMenu />
      <p className="p-0 m-0 px-3">
        {stringToPascal(props?.user?.firstName.toUpperCase() ?? "loading...")}
      </p>
      <UserIcon setIsShown={setIsShown} isShown={isShown} />
      <Tooltip
        id="user-dropdown"
        noArrow={true}
        className="tooltip user-dropdown-con"
        place="bottom-end"
        clickable
        render={() => (
          <UserDropdown
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}
            isHideNonInventoryOptions={isHideNonInventoryOptions}
          />
        )}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  currentStore: state.store.currentStore,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopbarUserContainer);
